
export default {
    props: {
        src: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        level: {
            type: Number,
            default: 1,
        },
        align: {
            type: String,
            default: '',
        },
    },
}
